import styles from "./style.module.scss";
import XIcon from "assets/icons/XIcon";
import MonoButton from "views/atomComponents/MonochromeButton";

const Modal = ({
  title,
  subtitle,
  description,
  titleIcon,
  primaryLoading = false,
  primaryActionLabel,
  secondaryActionLabel,
  onPrimaryActionClick,
  onSecondaryActionClick,
}: ModalProps) => {
  return (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <div className={styles.titleContainer}>
            {titleIcon}
            <span className={styles.title}>{title}</span>
          </div>
          <span onClick={onSecondaryActionClick} className={styles.crossIcon}>
            <XIcon />
          </span>
        </div>
        <span className={styles.divider} />
        <div className={styles.subtitle}>{subtitle}</div>
        <span className={styles.description}>{description}</span>
        <span className={styles.divider} />
        <div className={styles.buttonContainer}>
          <MonoButton
            className={styles.cancelButton}
            label={primaryActionLabel || "Cancel"}
            onClick={onSecondaryActionClick}
            variant="secondary"
          />
          <MonoButton
            className={styles.confirmButton}
            label={secondaryActionLabel || "Confirm"}
            loading={primaryLoading}
            onClick={onPrimaryActionClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Modal;

interface ModalProps {
  title: string;
  titleIcon: JSX.Element;
  subtitle: string;
  description: string;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;
  primaryLoading?: boolean;
  onPrimaryActionClick: () => void;
  onSecondaryActionClick: () => void;
}
